import { USERS } from '@src/graphql/queries/user';
// eslint-disable-next-line import/no-extraneous-dependencies
import { usePaginatedFetchItems } from 'pe-core-frontend';
export const useUsers = ({ clientId, searchText }) => {
    const { page, setPage, pageSize, setPageSize, total, items: users, loading, error, find, orderBy, orderByDir, setOrderBy, setOrderByDir, } = usePaginatedFetchItems({
        spec: { clientId, searchText },
        fetchQuery: USERS,
        dataProp: 'users',
        initialPageSize: 10,
    });
    return {
        users,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        error,
        total,
        find,
        orderBy,
        orderByDir,
        setOrderBy,
        setOrderByDir,
    };
};
